import { render, staticRenderFns } from "./GroupChatModal.vue?vue&type=template&id=8d4c46e0&scoped=true&"
import script from "./GroupChatModal.vue?vue&type=script&lang=js&"
export * from "./GroupChatModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupChatModal.vue?vue&type=style&index=0&id=8d4c46e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4c46e0",
  null
  
)

export default component.exports